<template>
  <h2 class="nx-scrollytelling-slide-title">{{ title }}</h2>
</template>

<script>
export default {
  name: 'nx-scrollytelling-slide-title',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/stylus/variables.styl'

.nx-scrollytelling-slide-title {
  height: 24px
  font-family: Roboto, serif
  font-size: 17px
  font-weight: 500
  font-stretch: normal
  font-style: normal
  line-height: 1.41
  letter-spacing: normal
  text-transform: uppercase
  color: $nx-primary--darken-1;
}
</style>
